<template>
    <div>
        <Query ref="queryRef" :reload.sync="reload" :query="query" :loading="loading" :allowedPlatList="allowedPlatList" @query-click="handleQueryClick"/>
        <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5">
            <div class="operation-box mb10">
                <div class="operation-left">
                    <el-button v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: '添加任务', value: '' }" type="primary" size="mini"  v-if="getCurAuth('add_task')" @click="handleAddClick">添加任务</el-button>
                </div>
                <div class="operation-right">

                </div>
            </div>
            <JtTable
                :data="tableData"
                style="width: 100%"
                :header-cell-style="{ background: '#e8eaec', color: '#333' }"
                size="mini"
                ref="refs_table"
                v-loading="loading"
            >
                <el-table-column
                    prop="id"
                    label="任务ID"
                    min-width="100"
                >

                    <template slot-scope="scope">
                        <span>{{scope.row.id}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="plat_id"
                    label="媒体"
                    min-width="100"
                >

                    <template slot-scope="scope">
                        <span>{{scope.row.plat_name}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="operation_level"
                    label="操作层级"
                    min-width="100"
                >

                    <template slot-scope="scope">
                        <span>{{scope.row.operation_level_text}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="display_operation_type"
                    label="操作项"
                    min-width="200"
                >

                    <template slot-scope="scope">
                        <span>{{scope.row.display_operation_type}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="display_operation_items"
                    label="操作内容"
                    min-width="200"
                >

                    <template slot-scope="scope">
                        <HoverEllipsisTips :text="scope.row.display_operation_items"/>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="display_operation_items"
                    label="操作目标"
                    min-width="140"
                >

                    <template slot-scope="scope">
                        <span>{{scope.row.operation_target_type_text}}*{{scope.row.operation_target_num}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="display_operation_items"
                    label="状态"
                    min-width="140"
                >

                    <template slot-scope="scope">
                        <div v-if="scope.row.status==0">
                            <!--查询中-->
                            <span style="color: #409eff;">{{scope.row.status_text}}<i class="el-icon-loading"></i></span>
                        </div>
                        <div v-else-if="scope.row.status==1">
                            <!--排队中-->
                            <span style="color: #7F7F7F;">{{scope.row.status_text}}<i class="el-icon-loading"></i></span>
                        </div>
                        <div v-else-if="scope.row.status==2">
                            <!--修改中-->
                            <span style="color: #409eff;">{{scope.row.status_text}}<i class="el-icon-loading"></i></span>
                        </div>
                        <div v-else-if="scope.row.status==3">
                            <!--修改成功-->
                            <span style="color: #619f53;">{{scope.row.status_text}}</span>
                        </div>
                        <div v-else-if="scope.row.status==4">
                            <!--修改失败-->
                            <el-tooltip class="item" effect="dark"  placement="top" v-if="scope.row.err_msg">
                                <div slot="content" style="max-height: 50vh; max-width: 400px;overflow-y: auto;">
                                    <p class="mb6">您可点击详情查看具体失败内容，失败原因汇总如下：</p>
                                    <div v-html="scope.row.err_msg"></div>
                                </div>
                                <span class="pointer" style="color: #ed4014;">{{scope.row.status_text}}<i class="el-icon-warning-outline"></i></span>
                            </el-tooltip>
                            <span v-else class="pointer" style="color: #ed4014;">{{scope.row.status_text}}</span>
                        </div>
                        <div v-else-if="scope.row.status==5">
                            <!--部分修改失败-->
                            <el-tooltip class="item" effect="dark"  placement="top" v-if="scope.row.err_msg">
                                <div slot="content" style="max-height: 50vh; max-width: 400px;overflow-y: auto;">
                                    <p class="mb6">您可点击详情查看具体失败内容，失败原因汇总如下：</p>
                                    <div v-html="scope.row.err_msg"></div>
                                </div>
                                <span class="pointer" style="color: #ed4014;">{{scope.row.status_text}}<i class="el-icon-warning-outline"></i></span>
                            </el-tooltip>
                            <span v-else class="pointer" style="color: #ed4014;">{{scope.row.status_text}}</span>
                        </div>
                        <div v-else-if="['6','7','8'].includes(scope.row.status)">
                            <!--终止-->
                            <el-tooltip class="item" effect="dark"  placement="top" v-if="scope.row.err_msg">
                                <div slot="content" style="max-height: 50vh; max-width: 400px;overflow-y: auto;">
                                    <div v-html="scope.row.err_msg"></div>
                                </div>
                                <span class="pointer" style="color: #ed4014;">{{scope.row.status_text}}<i class="el-icon-warning-outline"></i></span>
                            </el-tooltip>
                            <span v-else class="pointer" style="color: #ed4014;">{{scope.row.status_text}}</span>
                        </div>
                    </template>
                </el-table-column>
                 <el-table-column
                    prop="source_module"
                    label="任务来源模块"
                    min-width="100"
                />
                 <el-table-column
                    prop="source_info"
                    label="任务来源信息"
                    min-width="200"
                />
                 <el-table-column
                    prop="source_user"
                    label="任务来源人"
                    min-width="100"
                />

                <el-table-column
                    prop="creator"
                    label="创建人"
                    min-width="100"
                >

                    <template slot-scope="scope">
                        <span>{{scope.row.creator}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="create_time"
                    label="创建时间"
                    min-width="140"
                >

                    <template slot-scope="scope">
                        <span>{{scope.row.create_time}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    min-width="170"
                    fixed="right"
                >

                    <template slot-scope="scope">
                        <div>
                            <el-button type="text" size="mini"
                                        v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: '复制' }"
                                        :loading="scope.row.loading"
                                        @click="()=>handleCopyDataClick(scope.row)"
                                       :style="{color: '#409EFF'}" v-if="getCurAuth('copy_task')">复制</el-button>
                            <el-button type="text" size="mini" :disabled="scope.row.status != 4 && scope.row.status != 5"
                                       :style="{color:scope.row.status != 4 && scope.row.status != 5  ? '#d3d3d3' : '#409EFF'}"
                                       v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: '重试' }"
                                       v-if="getCurAuth('retry_task')" @click="retry(scope.row)">重试</el-button>
                            <el-button type="text" size="mini" @click="info(scope.row)" v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: '详情' }">详情</el-button>
                            <el-button  
                                v-if="getCurAuth('stop_task')" 
                                type="text" size="mini" 
                                :disabled="scope.row.status == 3 ||scope.row.status == 4 || scope.row.status == 5 || scope.row.status == 6|| scope.row.status == 7"
                                @click="handleStopTask(scope.row)" 
                                v-matomo="{behaviorCategory: '广告批量调控', event: '点击',  name: '终止' }"
                                :loading="scope.row.stopLoading"
                            >
                                <span  :style="{color:scope.row.status == 3 ||scope.row.status == 4 || scope.row.status == 5 || scope.row.status == 6 || scope.row.status == 7 ? '#d3d3d3' : '#ed4014'}">终止</span>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </JtTable>
            <div class="tar pt20 pr20">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

import Query from "./query.vue";
import HoverEllipsisTips from "@/views/workOrder/components/hoverEllipsis.vue";
import API from "@/api/efficiencyTool/ads.js"
import { copyAdjustmentDataApi } from '@/api'
import {infoMoal} from '../../modal/index'
import { JtTable } from '@/components/Ele';
import matomoFun from "@/utils/matomo.js";

export default {
    name: 'AdBatchAdjustmentPage',
    components: {HoverEllipsisTips, Query, JtTable},
    props:{
        reload:{
            type: [String,Boolean],
            default: ''
        },
        allowedPlatList: Array,
        pageFuncNames:Array,
        query: Object,
    },
    data() {
        return {
            queryData:{},
            currentPage: 1,
            pageSize: 30,
            pageNum: 1,
            tableData: [],
            total: 0,
            loading: false,
            exportLoading: false,
            updateIds: [],
            lock: false,
            isRefresh: true
        }
    },
    methods: {
        handleStopTask(row) {
             this.$prompt('请输入终止原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /.{1}/,
                inputErrorMessage: '请输入终止原因'
            }).then(({ value }) => {
                this.$set(row, 'stopLoading', true)
                API.postStopTaskApi({
                    task_id: row.id,
                    stop_msg: value
                }).then(res=>{
                    this.$message.success('终止成功')
                    this.fetchGetList({...this.queryData, pn:this.currentPage,rn:this.pageSize})
                    this.$set(row, 'stopLoading', false)
                }).catch(err=>{
                    this.$message.error(err.info)
                    this.$set(row, 'stopLoading', false)
                })
            }).catch(() => { });
        },
        handleAddClick() {
            this.$emit('changePage', 'TaskPage' )
        },
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name);
        },
        handleQueryClick(params) {
            this.queryData = params
            let res_params = {...this.queryData, pn:1,rn:this.pageSize}
            this.fetchGetList(res_params)
        },
        fetchGetList(params) {
            this.loading = true
            API.postListApi(params).then((res)=>{
                if (!params.export) {
                    const changeIds = [];
                    this.tableData = res?.data?.list ? res.data.list.map(item=>{
                        if ([ '0', '1', '2' ].includes(item.status)) {
                            changeIds.push(item.id)
                        }
                        return {
                            ...item,
                        }
                    }) : []
                    this.total = res.data.totalCnt
                    this.updateIds = changeIds
                    this.exportLoading = false
                    this.loading = false
                    this.updateListStatus()
                }else{
                    // 导出的情况
                    this.exportLoading = false
                    this.loading = false
                    this.$message.success(res.info)
                }
            }, err=>{
                this.loading = false
                this.$message.error(err.info)
            })
        },
        updateListStatus() {
            if (this.lock || !this.updateIds.length || !this.isRefresh) {
                return
            };
            this.timer = 5
            this.lock = true;
            let time = null;
            time = setInterval(()=> {
                if (this.timer<=0) {
                    clearInterval(time);
                    // this._updateListStatus()
                    API.getListStatusApi({task_ids: this.updateIds.join(',')}).then(res=>{
                        let res_list = res.data
                        if(res_list.length !==0) {
                            this.tableData = this.tableData.map(v=> {
                                res_list.forEach((item, index)=>{
                                    if(item.id == v.id) {
                                        if (![ '0', '1', '2' ].includes(item.status)) {
                                            this.updateIds.splice(index, 1)
                                        }
                                        v.status = item.status
                                        v.status_text = item.status_text
                                        v.err_msg = item.err_msg ? item.err_msg : ''
                                    }
                                })
                                return {...v}
                            })
                        }
                    }).finally(()=>{
                        this.lock = false
                        if (this.updateIds) {
                            this.updateListStatus()
                        }
                    })
                }else {
                    --this.timer
                }
            }, 1000)
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            let res_params = {...this.queryData, pn:this.currentPage,rn:this.pageSize}
            this.fetchGetList(res_params)
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            let res_params = {...this.queryData, pn:this.currentPage,rn:this.pageSize}
            this.fetchGetList(res_params)
        },
        // 重试
        retry(params) {
            API.postReApi({task_id: params.id}).then(res=>{
                this.$message.success(res.info)
                let res_params = {...this.queryData, pn:this.currentPage,rn:this.pageSize}
                this.fetchGetList(res_params)
            },err=>{
                this.$message.error(err.info)
            })
        },
        info(params) {
            const {vm} = infoMoal({
                props:{
                  id: params.id,
                  pageFuncNames:this.pageFuncNames
                },
                cbs: {
                    onSubmit: (data, callback)=> {
                    }
                },
                on:{
                    close:()=>{
                        matomoFun.trackEvent('广告批量调控', '点击', '详情(关闭)');
                        vm.close();
                    },
                }
            })
        },
        async handleCopyDataClick(data) {
            try {
                this.$set(data, 'loading', true)
                const params = {
                    task_id:  data.id
                }
                await copyAdjustmentDataApi(params);
                this.$emit('changePage', 'TaskPage', data  )
            } catch (error) {
                this.$message.error(error.info)
            }finally{
                this.$set(data, 'loading', false)
            }   
        }

    },
    activated() {
        this.isRefresh = true;
        let res_params = {...this.queryData, pn: this.currentPage,rn:this.pageSize}
        this.fetchGetList(res_params)
    },
    beforeDestroy() {
        this.isRefresh = false
        this.updateIds = [];
    },
    deactivated() {
        this.isRefresh = false
        this.updateIds = []
    }

}
</script>
<style lang="scss" scoped>
.bg-white{
    background-color: #fff;
}
</style>
